define('home/views/WelcomeView',[
    'backbone-marionette',

    'core/utils/url/parseQueryString',

    'home/templates/welcome',
], function (
    Marionette,

    parseQueryString,

    welcomeTemplate
) {
    'use strict';

    return Marionette.ItemView.extend({
        template: welcomeTemplate,

        templateHelpers: function () {
            return {
                user: this.session.user.toJSON(),
                registeredThisWeek: this.session.user.registeredThisWeek(),
                showVerifiedMessage: this.showVerifiedMessage(),
            };
        },

        events: {
            'click [data-action=complete-onboarding]': 'completeOnboarding',
        },

        initialize: function (options) {
            this.session = options.session;
            this.listenTo(this.session, 'change:id', this.render);
        },

        showVerifiedMessage: function () {
            return Boolean(parseQueryString().email_verified);
        },

        getMetaAttrs: function () {
            return 'Welcome';
        },

        completeOnboarding: function () {
            this.session.user.setHomeOnboardComplete(true);
        },

    });
});

